import { Component, OnDestroy, OnInit } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { DataStorageService } from "assurcard-angular-library";
import { combineLatest, filter, interval, Observable, Subscription } from "rxjs";
import { filterNullOrUndefined } from "src/app/@operators/filter-null-or-undefined";
import { TranslationService } from "src/app/core/services/translation.service";
import { AppState, getState, resetStates } from "src/app/state/app.state";
import { environment } from "src/environments/environment";
import { stopWithError } from "../../archospi/state/archospi.actions";
import { getSelectedInsurerWebLink, getSelectedInsurerPhoneNumber, getSelectedLanguage } from "../../transaction-info/state/transaction-info.selectors";
import { ErrorLevel } from "../error-level";
import { setErrorMsg } from "../state/error.actions";
import { getErrorLevel, getErrorMsg, getKioskError } from "../state/error.selectors";
import { Router } from "@angular/router";

@Component({
    selector: "app-error-page",
    templateUrl: "./error-page.component.html",
    styleUrls: ["./error-page.component.scss"],
    standalone: false
})
export class ErrorPageComponent implements OnInit,OnDestroy {
	private errorMsg$: Observable<string> = this.store.pipe(select(getErrorMsg));
	public errorMsg: string;
	public insurerMessage: string;
	private subs: Subscription[] = [];
	public lang: string;
	public insurerPhone: string;
	public insurerWebLink: string;
	public environment = environment;
	public errorLevel: ErrorLevel;

	public errorMsgAllLanguage = false;
	public errorMsgFR: string;
	public errorMsgNL: string;
	public errorMsgEN: string;
	public errorMsgDE: string;

	public displayCountdown: boolean;
	public titleCountdown: string;
	public numberCountdown = 0;
	private countdownInterval: any;
	private state: AppState;

	constructor(private store: Store<AppState>, private translationService: TranslationService, private router: Router) {
		this.subs.push(getState(this.store).subscribe(state => this.state = state));
	}

	ngOnInit(): void {
		this.subs.push(
			this.store
				.pipe(select(getSelectedInsurerWebLink))
				.pipe(filterNullOrUndefined())
				.subscribe((_) => {
					this.insurerWebLink = _;
				})
		);

		this.subs.push(
			this.store
				.pipe(select(getSelectedInsurerPhoneNumber))
				.pipe(filterNullOrUndefined())
				.subscribe((_) => {
					this.insurerPhone = _;
				})
		);

		this.subs.push(this.store.pipe(select(getErrorLevel)).subscribe((_) =>
			this.errorLevel = (_ == undefined) ? ErrorLevel.ERROR : _
		));

		this.subs.push(
			combineLatest([
				this.errorMsg$.pipe(filterNullOrUndefined()),
				this.store.pipe(select(getSelectedLanguage))
			])
			.pipe(filter(([_, selectedLanguage])=> selectedLanguage != undefined))
			.subscribe(([message, selectedLanguage]) => {
				this.displayCountdown = this.state.error.displayCountdown && environment.kioskMode;
				if (this.displayCountdown === true) {

					this.countdownInterval = setInterval(() => {
						this.numberCountdown++;
						if (this.numberCountdown == 10) {
							this.onHome();
						}
					}, 100000)
				}

				if (this.state.error.noTranslation === true) {
					this.errorMsg = message;
				} else {
					//if language is not available => translate in all languages
					if (selectedLanguage ===  undefined || selectedLanguage ===  null) {
						this.errorMsgAllLanguage = true;
						this.translationService.getTranslationInTargetLanguage(message, "FR").subscribe((_) => {
							this.errorMsgFR = _;
						});
						this.translationService.getTranslationInTargetLanguage(message, "NL").subscribe((_) => {
							this.errorMsgNL = _;
						});
						this.translationService.getTranslationInTargetLanguage(message, "EN").subscribe((_) => {
							this.errorMsgEN = _;
						});
						this.translationService.getTranslationInTargetLanguage(message, "DE").subscribe((_) => {
							this.errorMsgDE = _;
						});
					} else {
						this.errorMsg = this.translationService.getInstant(message);
					}
				}

			})
		);

		this.subs.push(this.store.pipe(select(getKioskError)).subscribe((kioskError) => {
			if (this.state.archospi.arcHospi != undefined)
				this.store.dispatch(stopWithError({ kioskError: kioskError }));
		}));

		if (environment.kioskMode && window.external.EndProcess){
			this.subs.push(
				interval(30_000).subscribe(() => {
					window.external.EndProcess();
				})
			);
		}
	}

	ngOnDestroy(): void {
		this.store.dispatch(setErrorMsg(undefined));
		this.subs.forEach((_) => _.unsubscribe());
	}

	onHome() {
		if (environment.kioskMode && window.external.EndProcess){
			window.external.EndProcess();
		}
		clearInterval(this.countdownInterval);
		resetStates(this.store);
		this.router.navigate(["app-login"]);
	}
}



